import React from "react";

import caseStudies from "../../data/caseStudies";

import CaseStudyCard from "../cards/CaseStudyCard";

function CaseStudyGrid() {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns:
          "repeat(auto-fit,minmax(340px,1fr))",
        gap: "28px"
      }}
    >
      {caseStudies.map((study) => (
        <CaseStudyCard
          key={study.slug}
          study={study}
        />
      ))}
    </div>
  );
}

export default CaseStudyGrid;